import React from 'react';
import Navbar from './Header/Navbar';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import styles from './layout.module.css';
import Footer from './Footer/Footer';

const Layout = () => {
  const ASSETS = {
    dgca: 'Assets/Images/Common/DGCA.svg',
    wpc: 'Assets/Images/Common/wpc.svg',
  };
  
  const location = useLocation();
  
  // Check if URL contains "axlOneView" to determine which badge to show
  const showWpcBadge = location.pathname.includes('axlOneView');
  const currentBadge = showWpcBadge ? ASSETS.wpc : ASSETS.dgca;
  const badgeAlt = showWpcBadge ? 'WPC Certification' : 'DGCA Certification';
  
  return (
    <div className={styles.layoutWrapper}>
      <header className={styles.headerSection}>
        <Navbar />
      </header>

      {/* Main Content Section */}
      <main className={styles.mainContent}>
        <img
          src={currentBadge}
          alt={badgeAlt}
          className={styles.badge}
          // width="200"
          // height="100"
          loading="eager"
        />
        <Outlet />
      </main>

      {/* Conditional Wave Section */}
      {location.pathname === "/" && (
        <section className={styles.waveSection}>
          <div className={styles.wave}></div>
        </section>
      )}

      {/* Footer Section */}
      <footer className={styles.footerSection}>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;